import template from "./bMatchActions.html";

export function bMatchActionsDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bMatchActionsController,
    controllerAs: 'bMatchActions',
    bindToController: true,
    scope: {
      entity: "=",
      entityToMatch: "=",
      edit: "&",
      cancel: "&",
      save: "&",
      saveEdit: "&",
      delete: "&",
      blockSave: "=?",
      blockMatch: "=?",
      hideDelete: "=?"
    }
  };

  return directive;
}

class bMatchActionsController {
  constructor() {
    'ngInject';
  }

  editEntity(entity, fEdit) {
    entity.edited = true;
    fEdit({entity});
  }

  cancelAction(entity, fCancel) {
    entity.edited = false;
    fCancel({entity});
  }

  saveEntityMatch(entity,entityToMatch,fSave) {
    entity.edited = false;
    fSave({entity,entityToMatch});
  }

  saveEntityEdit(entity,entityToMatch,fSaveEdit) {
    entity.edited = false;
    fSaveEdit({entity,entityToMatch});
  }

  deleteEntity(entity, fDelete) {
    fDelete({entity});
  }
}